<template>
    <div class="feedback p-4">

        <div v-if="feedbacks.length == 0">
            <p class="text-center mb-0">{{ $t('feedbacks.no-'+type) }}</p>
        </div>
        
        <div v-else class="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">
            <div v-for="(feedback, index) in feedbacks" :key="index" class="timeline-block">

                <span class="timeline-step badge-default">
                    <i class="fas fa-thumbtack"></i>
                </span>
                
                <div class="timeline-content">

                    <feedback :feedback="feedback"
                        :registration="registration"
                        :simulation="simulation"
                        :lang="registration.degree.lang"
                        :edit="true"
                        :sharing="false"
                        :session="session"
                        :show-me="true"
                        :show-positions="true"
                        :prefer-learner-summary="true"
                        @update="update"
                        @remove="remove"
                    >
                    </feedback>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import SessionRecipient from '../common/SessionRecipient'
    import Feedback from '../common/Feedback'

    export default {

        components: {
            SessionRecipient, Feedback
        },

        props: {

            modal: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                required: true
            },

            timeslot: {
                type: Object,
                default: null
            },

            type: {
                type: String,
                required: true
            },

            competencies: {
                type: Object,
                default: null
            },
        },

        data() {
            let endpoint = this.session
                ? '/astral/api/front/dashboard/sessions/' + this.session.id + '/feedbacks'
                : '/astral/api/front/dashboard/registrations/' + this.registration.id + '/simulations/' + this.simulation.id + '/feedbacks'


            let client = new CrudClient(endpoint, {
                type: this.type,
                timeslot_id: this.timeslot ? this.timeslot.id : null,
            })
            return {
                endpoint,
                client,
                feedbacks: [],
                loaded: false,
            }
        },

        watch: {

            modal(val) {
                if (val.show) {

                    // Update the query now because timeslot may have changed.
                    this.client.query = {
                        type: this.type,
                        timeslot_id: this.timeslot ? this.timeslot.id : null,
                    }

                    // The modal has just been opened. Update the list.
                    this.list()
                }
            },
        },

        methods: {

            list() {
                this.loaded = false
                this.client.list().then(resp => {
                    this.feedbacks = resp.data.data.map(feedback => {

                        // In case the competency_ids is a string with commas. This may happen with the PWA.
                        if (typeof feedback.competency_ids === 'string') {
                            feedback.competency_ids = feedback.competency_ids === '' ? feedback.competency_ids = [] : feedback.competency_ids.split(',')
                        }

                        // In case we have an array of competency ids. This always happens with the PWA.
                        if (Array.isArray(feedback.competency_ids)) {
                            feedback.competencies = feedback.competency_ids.map(id => this.competencies[id])
                        }

                        // In case we have still no competencies. This happens with PWA for pilots (competencies are hidden).
                        if (feedback.competencies === undefined) {
                            feedback.competencies = []
                        }

                        return feedback
                    })
                    this.loaded = true
                })
            },

            update(feedback) {
                this.$emit('update', feedback)
            },

            remove(feedback) {
                this.$emit('remove', feedback)
            },
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    @media (min-width: 992px) {
        .timeline-one-side .timeline-content {
            max-width: none;
        }
    }
    .recipients {
        font-size: 80%;
        list-style-type: none;
        padding-left: 10px;
        margin-bottom: 0;
        border-left: dashed 1px #7182e4
    }

</style>
